import {
  Modal,
  Group,
  Button,
  Stack,
  SegmentedControlItem,
  Title,
} from '@mantine/core';
import { SwapSettings } from './SwapSettings';
import { useState } from 'react';

export function SwapSettingsModal({
  slippageValue,
  customSlippageValue,
  deadlineValue,
  onSlippageChange,
  onCustomSlippageChange,
  onDeadlineChange,
  onClose,
}: {
  slippageValue: string;
  customSlippageValue: string | undefined;
  deadlineValue: string | undefined;
  onSlippageChange: (value: string) => void;
  onCustomSlippageChange: (value: string | undefined) => void;
  onDeadlineChange: (value: string | undefined) => void;
  onClose: () => void;
}) {
  const [internalSlippageValue, setInternalSlippageValue] =
    useState(slippageValue);
  const [internalCustomSlippageValue, setInternalCustomSlippageValue] =
    useState<string | undefined>(customSlippageValue);
  const [internalDeadlineValue, setInternalDeadlineValue] = useState<
    string | undefined
  >(deadlineValue);

  const handleInternalSlippageChange = (value: string) => {
    setInternalSlippageValue(value);
    if (value !== 'custom') {
      setInternalCustomSlippageValue(undefined);
    }
  };

  const handleInternalCustomSlippageChange = (value: string | undefined) => {
    setInternalCustomSlippageValue(value);
  };

  const handleInternalDeadlineChange = (value: string | undefined) => {
    setInternalDeadlineValue(value);
  };

  const handleSave = () => {
    onSlippageChange(internalSlippageValue);
    onCustomSlippageChange(internalCustomSlippageValue);
    onDeadlineChange(internalDeadlineValue);
    onClose();
  };

  return (
    <Modal
      opened
      onClose={onClose}
      size={480}
      centered
      withCloseButton={false}
      classNames={{
        title: 'text-[32px] font-[600]',
        header: 'border-none !pb-0 mb-8',
      }}
    >
      <Title order={3} fz={24} fw={700} mb={24}>
        Settings
      </Title>
      <Stack gap={24}>
        <SwapSettings
          slippageValue={internalSlippageValue}
          customSlippageValue={internalCustomSlippageValue}
          compactSlippageValues={false}
          deadlineValue={internalDeadlineValue}
          onSlippageChange={handleInternalSlippageChange}
          onCustomSlippageChange={handleInternalCustomSlippageChange}
          onDeadlineChange={handleInternalDeadlineChange}
        />

        <Group gap={16} justify="flex-end" mt="md">
          <Button className="bg-[#151519] border-[#202027]" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="gradient" onClick={handleSave}>
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
